<template>
  <div style="margin-top:-10px !important">
    <div class="nav-container pad-nav">
      <!-- heading of the page -->
      <b-row class="px-pad border-bottom" style="height:42px">
        <b-col md="6" lg="6" sm="6" class="px-0">
          <span
            class="fw-semi-bold index-heading pl-0"
            style="position:relative;top:2px;"
          >GST Filing</span>
        </b-col>
      </b-row>
      <div style="margin-right:-10px;margin-left:-10px" class="mt-4">
        <b-row>
          <b-col md="12">
            <!-- initialize table for showing the overall gst reports detail based on the filtered month -->
            <b-row>
              <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                <b-nav vertical class="side-nav-content">
                  <!-- <h4 class="invoice mb-3">GST Filing</h4> -->
                  <b-nav-item
                    :to="{name:'GSTR1Transaction',query:{type:'b2b_return',month:(parseInt(new Date().getMonth()) + 1),year:new Date().getFullYear()}}"
                    class="sidenav-item active ul-pad"
                    active
                  >
                    <span class="fa fa-angle-right pr-3"></span>B2B Invoices (Taxable outward supplies for registered persons)
                  </b-nav-item>
                  <b-nav-item
                    :to="{name:'GSTR1Transaction',query:{type:'b2c_return',month:(parseInt(new Date().getMonth()) + 1),year:new Date().getFullYear()}}"
                    class="sidenav-item ul-pad"
                  >
                    <span class="fa fa-angle-right pr-3"></span>B2C Invoices (Taxable outward supplies to consumers)
                    by Product
                  </b-nav-item>
                  <b-nav-item
                    :to="{name:'GSTR1Transaction',query:{type:'hsn_return',month:(parseInt(new Date().getMonth()) + 1),year:new Date().getFullYear()}}"
                    class="sidenav-item ul-pad"
                  >
                    <span class="fa fa-angle-right pr-3"></span>Group by HSN ( Has both B2B and B2C)
                  </b-nav-item>
                  <b-nav-item
                    :to="{name:'GSTR1Transaction',query:{type:'total_return',month:(parseInt(new Date().getMonth()) + 1),year:new Date().getFullYear()}}"
                    class="sidenav-item ul-pad"
                  >
                    <span class="fa fa-angle-right pr-3"></span>Total Invoice details
                  </b-nav-item>
                  <b-nav-item
                    :to="{name:'GSTR1Transaction',query:{type:'sales_global_export',month:(parseInt(new Date().getMonth()) + 1),year:new Date().getFullYear()}}"
                    class="sidenav-item ul-pad"
                  >
                    <span class="fa fa-angle-right pr-3"></span>Invoice wise sales details
                  </b-nav-item>
                </b-nav>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GstfilingOverview"
};
</script>
